import { InbodyIndicatorInfo, IndicatorScanInfo } from '../../interfaces/inbodyIndicator';

import { findIndexByField } from '../../../shared/utils/arrayUtils/findIndexByField/findIndexByField';

const getFilteredScansData = (
  scans: IndicatorScanInfo[],
  startScanId: number,
  endScanId: number,
) => {
  const startIndex = findIndexByField(scans, { scanId: startScanId });
  const endIndex = findIndexByField(scans, { scanId: endScanId });

  if (startIndex !== -1 && endIndex !== -1) {
    const minIndex = Math.min(startIndex, endIndex);
    const maxIndex = Math.max(startIndex, endIndex);

    return scans.slice(minIndex, maxIndex + 1);
  } else {
    return scans;
  }
};

export const getFilteredInbodyIndicators = (
  inbodyIndicators: InbodyIndicatorInfo[],
  startScanId: number | null,
  endScanId: number | null,
) => {
  if (!startScanId || !endScanId) {
    return inbodyIndicators;
  }

  return inbodyIndicators.map((inbodyIndicator) => {
    if (!inbodyIndicator.scans) {
      return inbodyIndicator;
    }

    const filteredScans = getFilteredScansData(
      inbodyIndicator.scans,
      startScanId,
      endScanId,
    );

    return {
      ...inbodyIndicator,
      scans: filteredScans,
    };
  });
};
